import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GetViews } from '../../graphql/queries'
import './style.scss'
import FilterTable from '../../components/FilterTable'
import ViewsFilters from '../../components/ViewsFilters'
import { capitalizeName } from '../../util/string'

const includeFields = [
    {
        value: 'distribution',
        label: 'Jaotus',
    },
    {
        value: 'year',
        label: 'Jaotuse aasta',
    },
    {
        value: 'creationTitle',
        label: 'Teos',
    },
    {
        value: 'creationSeason',
        label: 'Hooaeg',
    },
    {
        value: 'creationEpisode',
        label: 'Seeria',
    },
    {
        value: 'creationYear',
        label: 'Teose aasta',
    },
]

const UserViewsScreen = () => {

    const { t } = useTranslation()
    const tableRef = useRef()
    const filtersRef = useRef()

    const [extraFilters, setExtraFilters] = useState()

    const fieldConditions = (row, field) => {
        switch (field) {
            case 'distribution':
                return row.distribution
            case 'creationTitle':
                return capitalizeName(row.creation.title)
            case 'creationSeason':
                return row.creation.season
            case 'creationEpisode':
                return row.creation.episode
            case 'creationYear':
                return row.creation.year
            default:
                return row[field]
        }
    }

    const handleFilterChange = async (filters) => {
        setExtraFilters(filters)
    }

    return (
        <div className='user-views'>
            <div className='inner'>
                <ViewsFilters
                    ref={filtersRef}
                    onFilterChange={handleFilterChange}
                />
                <div className='filter-table--container'>
                    <FilterTable
                        ref={tableRef}
                        query={GetViews}
                        fieldConditions={fieldConditions}
                        queryKey={'getViews'}
                        hideInputs={true}
                        initialOrderBy={'distribution'}
                        includeFields={includeFields}
                        extraFilters={extraFilters}
                        useExtraFilters={true}
                        allowSelect={true}
                        queryOptions={{
                            fetchPolicy: 'no-cache',
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default UserViewsScreen